import { getGlobalObject } from '../tools/utils';
export function getEventBridge() {
  var eventBridgeGlobal = getEventBridgeGlobal();
  if (!eventBridgeGlobal) {
    return;
  }
  return {
    getAllowedWebViewHosts: function () {
      return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
    },
    send: function (eventType, event) {
      eventBridgeGlobal.send(JSON.stringify({
        eventType: eventType,
        event: event
      }));
    }
  };
}
export function canUseEventBridge(hostname) {
  var _a;
  if (hostname === void 0) {
    hostname = (_a = getGlobalObject().location) === null || _a === void 0 ? void 0 : _a.hostname;
  }
  var bridge = getEventBridge();
  return !!bridge && bridge.getAllowedWebViewHosts().some(function (host) {
    var escapedHost = host.replace(/\./g, '\\.');
    var isDomainOrSubDomain = new RegExp("^(.+\\.)*".concat(escapedHost, "$"));
    return isDomainOrSubDomain.test(hostname);
  });
}
function getEventBridgeGlobal() {
  return getGlobalObject().DatadogEventBridge;
}
